import React, { PureComponent } from 'react';
import { intervalToDuration, formatDuration } from 'date-fns';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import './Countdown.scss';
import customLocale from '../../configs/date-fns';

class Countdown extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      time: null
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      const duration = intervalToDuration({
        start: this.props.timeTillDate,
        end: Date.now()
      });
      const daysToHours = duration.days * 24;
      duration.hours += daysToHours;

      const time = formatDuration(duration, {
        format: ['hours', 'minutes', 'seconds'],
        zero: true,
        delimiter: this.props.type === 'small' ? ':' : ' ',
        locale: customLocale
      });

      this.setState({ time });
    }, 1000);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  renderCountDown = () => {
    const { t } = this.props;

    return (
      <div className="countdown">
        <span className="countdown__remaining">
          { this.state.time }
        </span>
        <div className="countdown__info">
          <span className="countdown__time">{ t('countdown.hour') }</span>
          <span className="countdown__time">{ t('countdown.min') }</span>
          <span className="countdown__time">{ t('countdown.sec') }</span>
        </div>
      </div>
    );
  }

  renderSmallCountDown = () => {
    return (
      <div className="countdown">
        <span className="countdown__remaining">
          { this.state.time }
        </span>
      </div>
    );
  }

  render() {
    return (
      this.props.type == 'small' ?
        this.renderSmallCountDown()
        :
        this.renderCountDown()
    );
  }
}

Countdown.propTypes = {
  t: PropTypes.func,
  type: PropTypes.string,
  timeTillDate: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)])
};

export default withTranslation('common')(Countdown);
